<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 대분류 -->
							<th>* {{ getMessage_('QWCC001122') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="selectedRow.ckuLgrpCd"
									:options="selectedRow.creDataScnCd === 'M' ? getLgrpListM_ : getLgrpListQ_"
									:onChange="val => setSelectedRow(val, 'ckuLgrpCd')"
									:placeholder="getMessage_('QWCC001122')"
									:disabled="isDisabled"
								/>
							</td>
							<!-- 소분류 -->
							<th>* {{ getMessage_('QWCC001123') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="selectedRow.ckuSgrpCd"
									:options="selectedRow.creDataScnCd === 'Q' && isNew === false ? sgrpAllList : sgrpList"
									:onChange="val => setSelectedRow(val, 'ckuSgrpCd')"
									:placeholder="getMessage_('QWCC001123')"
									:disabled="isDisabled"
								/>
							</td>
							<!-- 방식 -->
							<th>{{ getMessage_('QWCC001213') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="selectedRow.ipnWayCd"
									:options="ipnWayList"
									:onChange="val => setSelectedRow(val, 'ipnWayCd')"
									:placeholder="getMessage_('QWCC001213')"
								/>
							</td>
							<!-- 항목 -->
							<th>* {{ getMessage_('QWCC001215') }}</th>
							<td colspan="5">
								<el-input
									maxlength="65"
									:show-word-limit="true"
									:value="selectedRow.ipnPrvsSbc"
									@input="val => setSelectedRow(val, 'ipnPrvsSbc')"
									:readonly="isManufacture"
								/>
							</td>
						</tr>
						<tr>
							<th>T(SPEC)</th>
							<td>
								<el-input :value="selectedRow.obveScpVal" @input="val => setSelectedRow(val, 'obveScpVal')" maxlength="15" />
							</td>
							<th>MIN</th>
							<td>
								<el-input :value="selectedRow.minVal" @input="val => setSelectedRow(val, 'minVal')" maxlength="11" />
							</td>
							<th>MAX</th>
							<td>
								<el-input :value="selectedRow.maxVal" @input="val => setSelectedRow(val, 'maxVal')" maxlength="11" />
							</td>
							<!-- 단위 -->
							<th>{{ getMessage_('QWCC001124') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="selectedRow.utmCd"
									:options="utmList"
									:onChange="val => setSelectedRow(val, 'utmCd')"
									:placeholder="getMessage_('QWCC001124')"
								/>
							</td>
							<!-- 중요도 -->
							<th>{{ getMessage_('QWCC001243') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="selectedRow.icrtCd"
									:options="icrtList"
									:onChange="val => setSelectedRow(val, 'icrtCd')"
									:placeholder="getMessage_('QWCC001243')"
								/>
							</td>
							<!-- 사용여부 -->
							<th>{{ getMessage_('QWCC001163') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="selectedRow.useYn"
									:options="useYnList"
									:onChange="val => setSelectedRow(val, 'useYn')"
									:placeholder="getMessage_('QWCC001163')"
								/>
							</td>
						</tr>
						<tr>
							<!-- 사진 -->
							<th>{{ getMessage_('QWCC001244') }}</th>
							<td colspan="5" class="w-100 m-auto">
								<template v-if="isPhotoEditable_">
									<template v-if="isLoaded">
										<file-upload
											id="fwdImgFile"
											ref="fwdImgFileRef"
											width="100%"
											height="100%"
											:propFileObject="selectedRow.fwdImgFileDb"
											:isEditable="isPhotoEditable_"
											accept="image/jpeg,image/gif,image/png"
											@singleFile="fileUpload"
											@onDownload="onDownloadFile"
										></file-upload>
									</template>
								</template>
								<template v-else>
									{{ getMessage_('QWCC001328') }}
								</template>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import FileUpload from '@qms/Components/FileUpload.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: true
		};
	},
	components: { FileUpload },
	computed: {
		...rootComputed,
		...serviceComputed,
		isManufacture() {
			return this.selectedRow.creDataScnCd === 'M' ? true : false;
		},
		isDisabled() {
			//신규건이 아니고, MES에서 받은 데이터가 아닐경우
			return !this.isNew && this.selectedRow.creDataScnCd !== 'M';
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		fileUpload(value) {
			this.setSelectedRow_({ key: 'fwdImgFile', value });
		},
		async onDownloadFile(file) {
			const { fileId } = file;
			await this.fileDownload_({ fileId, fileSeq: 1 });
		},
		async setSelectedRow(value, key) {
			//숫자 길이 7자리, 소수점 3자리로 입력 제한
			if (key === 'minVal' || key === 'maxVal') {
				value = value.replace(/[^-\.0-9]/g, '');
				const arr = value.toString().split('.');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 7) {
						value = value.slice(0, 7);
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 3) {
						arr[1] = arr[1].slice(0, 3);
					}
					if (arr[0].length > 7) {
						arr[0] = arr[0].slice(0, 7);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
			}
			const original = { ...this.selectedRow };
			this.setSelectedRow_({ key, value });

			if (key === 'ckuLgrpCd') {
				this.setSelectedRow_({ key: 'ckuSgrpCd', value: '' });
				await this.getSgrpList_();
				if (this.sgrpList?.length === 1) {
					this.setSelectedRow_({ key: 'ckuSgrpCd', value: this.sgrpList[0].value });
				}
			}
			if (this.selectedRow.creDataScnCd !== 'M') {
				if (key === 'ckuLgrpCd' || key === 'ckuSgrpCd') {
					const { ckuLgrpCd, ckuSgrpCd } = this.selectedRow;
					const dupItem = _.find(this.resultList, { ckuLgrpCd, ckuSgrpCd });
					const isSame = _.isEqual(this.oldSelectedRow, dupItem);

					const checkOw = () => {
						this.setState_({ key: 'selectedRow', value: dupItem });
						this.setState_({ key: 'oldSelectedRow', value: dupItem });
						this.setState_({ key: 'isNew', value: false });
					};

					if (!!dupItem && !isSame) {
						this.$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: this.getMessage_('QWCC001804'),
							buttons: [{ title: 'Ok', clickFn: checkOw }],
							closeFn: () => {
								this.setSelectedRow_({ key: 'ckuLgrpCd', value: '' });
								this.setSelectedRow_({ key: 'ckuSgrpCd', value: '' });
							}
						});
					}
				}
			}
		}
	}
};
</script>
